import styled from 'styled-components';

export const Container = styled.header`
  display: flex;
  align-items: center;

  background: #fff;
  border-bottom: 1px solid #eee;

  padding: 0 30px;
  height: 80px;
`;

